// src/hooks/useAuth.ts
import { useAppSelector } from "./useAppSelector";

export const useAuth = () => {
  const { user, isAuthenticated, loading, error } = useAppSelector((s) => s.auth);
  return { user, isAuthenticated, loading, error };
};

export default useAuth;
